import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const deleteDiscount = {
  name: "deleteDiscount" as const,
  input: z.object({ _id: zExt.objectId() }),
  output: z.object({ success: z.boolean() }),
};
